import Cancelimg from "../../../../assets/img/cancel-01.svg";
import { LuCameraOff, LuCalendarX2, LuRefreshCw } from "react-icons/lu";
import useTranslator from "../../../../hooks/useTranslator";
import {
  haveValue,
  getConsiderResult,
  ONFIDO_TOOLTIP_PRIORITY,
} from "../../../../helper/common";
import { KYC_STEP, KycStep } from "../hooks/useKycWorkflow";

interface IVerificationModal {
  showPopup: boolean;
  isGuarantor: boolean;
  heading: string;
  subheading: string;
  closeModalState: (value: boolean) => void;
  hideBackgroundImage?: boolean;
  buttonText?: string;
  setKycStep: (value: KycStep) => void;
  workflowResult?: Record<string, any> | null;
}

const getFailureIcon = (path: string) => {
  if (path?.startsWith("data_validation")) return LuCalendarX2;
  return LuCameraOff;
};

const getBreakdownInfo = (
  workflowResult: Record<string, any> | null | undefined,
  _t: (key: string) => string
) => {
  const breakdown =
    workflowResult?.document_data?.document_report?.breakdown ||
    workflowResult?.workflow_run?.output?.document_report?.breakdown;

  if (!breakdown) return null;

  for (const entry of ONFIDO_TOOLTIP_PRIORITY) {
    if (getConsiderResult(breakdown, entry.path)) {
      return {
        explanation: _t(entry.explanation),
        recommendedAction: _t(entry.recommended_action),
        icon: getFailureIcon(entry.path),
      };
    }
  }

  return null;
};

const VerificationFailedModal = ({
  showPopup,
  isGuarantor,
  heading,
  subheading,
  closeModalState,
  hideBackgroundImage,
  buttonText,
  setKycStep,
  workflowResult,
}: IVerificationModal) => {
  const { _t } = useTranslator();
  const breakdownInfo = getBreakdownInfo(workflowResult, _t);
  const FailureIcon = breakdownInfo?.icon;

  const tryAgain = () => {
    setKycStep(KYC_STEP.CAPTURE_FRONT);
    closeModalState(false);
  };
  return (
    <>
      {showPopup && (
        <div
          className={`kyc-verification-failed-overlay popup-overlay fixed inset-0 flex items-center justify-center z-50 wrapper-modal modal-fixed-screen ${isGuarantor ? "guarantorBg" : ""
            } ${hideBackgroundImage ? "hideBackgroundImage" : ""}`}
        >
          <div
            className="kyc-verification-failed popup-content2 popup-content bg-white kycDonePopup position-relative"
            role="dialog"
            aria-modal="true"
            aria-labelledby="kyc-verification-failed-heading"
            aria-describedby="kyc-verification-failed-subheading"
          >
            <div className="kyc-failed-close-top-button">
              <button
                type="button"
                className="kyc-failed-close-button"
                onClick={() => closeModalState(false)}
                aria-label={_t("close")}
              >
                <img src={Cancelimg} alt="" />
              </button>
            </div>
            <div className="row relativeposition mt-3 mb-2">
              <div className="col-12 d-flex gap-4 align-items-center justify-content-center heading-section">
                <div className="authenticateid-header text-center">
                  <img
                    className="kyc-failed-heading-icon"
                    src="/images/high-risk-icon.svg"
                    alt=""
                  />
                  <h4 id="kyc-verification-failed-heading">{heading}</h4>
                  <p id="kyc-verification-failed-subheading">{subheading}</p>
                </div>
              </div>
            </div>
            {breakdownInfo && FailureIcon && (
              <div className="kyc-failed-error-alert-wrapper">
                <div className="kyc-failed-error-alert" role="alert">
                  <div className="kyc-failed-error-alert__icon">
                    <FailureIcon aria-hidden="true" />
                  </div>
                  <div className="kyc-failed-error-alert__content">
                    <span>{breakdownInfo.explanation}</span>{" "}
                    {/* <span>{breakdownInfo.recommendedAction}</span> */}
                  </div>
                </div>
              </div>
            )}
            <div className="kyc-failed-button">
              <button
                type="button"
                className="btnNext uploadbtn kyc_failed_primary full_radius"
                onClick={tryAgain}
              >
                <LuRefreshCw aria-hidden="true" />
                <span>
                  {haveValue(buttonText) ? _t(buttonText!) : _t("tryAgain")}
                </span>
              </button>
              <button
                type="button"
                className="btnNext btnnextpre uploadbtn go_back_btn full_radius"
                onClick={() => closeModalState(false)}
              >
                {haveValue(buttonText) ? _t(buttonText!) : _t("goBack")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VerificationFailedModal;
